module.exports = __webpack_public_path__ + "static/media/IT.a64cca95.svg";